<template>
  <el-container class="dealer-container">
    <el-header class="header__nav">
      <dealerHeader>
        <!-- <template slot="menu_button">
          <er-button
            :class="`nav__controller`"
            @click="toggleNavigation"
            :icon="showControl ? 'el-icon-s-fold' : 'el-icon-s-unfold'"
          ></er-button>
        </template>-->
      </dealerHeader>
    </el-header>
    <router-view></router-view>
  </el-container>
</template>

<script>
import dealerHeader from "@/components/dealer/dealerHeader";
export default {
  components: {
    dealerHeader
  }
};
</script>

<style lang="scss">
.dealer-container {
  display: block;
  $header-height: 45px;
  $navigation-width-onopen: 200px;
  $navigation-width-onclose: 64px;
  box-sizing: border-box;
  //   height: 100vh;
  overflow: hidden;
  .header__nav {
    height: $header-height !important;
    position: relative;
    border-bottom: 1px solid #dcdfe6;
    top: 0px;
    left: 0px;
    right: 0px;
  }
  .header--padding {
    margin-left: 100px;
    margin-right: 100px;
  }
  .el-header {
    padding: 0px 10px;
  }
}
</style>